import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpClient } from '@angular/common/http';

// Storage
import { StorageService } from 'viasng-core';
// Globals
import { GlobalsService } from 'viasng-core';
// vias service
import { ViasConnectionService } from 'viasng-core';
// page meta loader service
import { PageMetaService } from 'viasng-core';

// Angular Material
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTableModule } from '@angular/material/table';
import { CdkTableModule} from '@angular/cdk/table';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
// Angular Flexlayout
import { FlexLayoutModule } from '@angular/flex-layout';
// ngx-translate
import {
  TranslateModule,
  TranslateLoader,
  TranslatePipe,
  MissingTranslationHandler,
  MissingTranslationHandlerParams
} from '@ngx-translate/core';

import { TranslateHttpLoader } from '@ngx-translate/http-loader';
// ngx-loading-bar
import { LoadingBarModule } from '@ngx-loading-bar/core';
// ngx-perfect-scrollbar
import {
  PerfectScrollbarModule,
  PERFECT_SCROLLBAR_CONFIG,
  PerfectScrollbarConfigInterface
} from 'ngx-perfect-scrollbar';


import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {
  ViasngCoreModule,
  ComponentsModule,
  MENUITEM_PROVIDER,
  MAIN_SERVER_URL,
  PRINT_URL,
  SERVER_URL,
  CONTRACTOR_SERVER_URL
 } from 'viasng-core';
import { mainServerURL, serverURL, contractorServerURL, printURL } from './globalVars';
import { MenuItems } from './menuItems';

// Translation Script
export function createTranslateLoader(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
export class MyMissingTranslationHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams): string {
    return params.key;
  }
}
// Scrollbar config
const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  wheelSpeed: 2,
  wheelPropagation: true
};

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    ViasngCoreModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      },
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: MyMissingTranslationHandler
      },
      useDefaultLang: false
    }),
    FormsModule,
    MatExpansionModule,
    MatSidenavModule,
    MatMenuModule,
    MatCheckboxModule,
    MatDialogModule,
    MatIconModule,
    MatTableModule,
    CdkTableModule,
    MatSnackBarModule,
    MatButtonModule,
    MatToolbarModule,
    MatTooltipModule,
    MatListModule,
    MatSelectModule,
    MatInputModule,
    MatCardModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    FlexLayoutModule,
    LoadingBarModule,
    PerfectScrollbarModule,
    ComponentsModule
  ],
  providers: [
    StorageService,
    GlobalsService,
    ViasConnectionService,
    {
      provide: MAT_DIALOG_DATA,
      useValue: {}
    },
    {
      provide: MatDialogRef,
      useValue: {}
    },
    {
      provide: MENUITEM_PROVIDER,
      useValue: MenuItems
    },
    {
      provide: MAT_DATE_LOCALE,
      useValue: 'tr-TR'
    },
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    },
    {
      provide: MAIN_SERVER_URL,
      useValue: mainServerURL
    },
    {
      provide: PRINT_URL,
      useValue: printURL
    },
    {
      provide: SERVER_URL,
      useValue: serverURL
    },
    {
      provide: CONTRACTOR_SERVER_URL,
      useValue: contractorServerURL
    }
  ],
  exports: [
    ComponentsModule,
    TranslateModule
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
